var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStreamlineClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 9.682 9.683"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.375 9.683a.373.373 0 01-.265-.109.377.377 0 010-.531L9.041.112a.375.375 0 01.531.53L.64 9.573a.374.374 0 01-.265.11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.307 9.683a.377.377 0 01-.266-.109L.11.64A.375.375 0 01.64.11l8.932 8.932a.377.377 0 01-.265.641z"
  }))));
}
export default SvgStreamlineClose;